export default __webpack_public_path__ + "static/media/logoMb.0e8bf891.png";